/* =====================================================================
   SH4DE v2 — achat rapide (accueil + fiche produit), combo, tiroir panier
   avec barre « livraison offerte », galerie, guide des tailles.
   Chargé en dernier (defer). Remplace le rendu du tiroir de sh4de-cart.js.
   ===================================================================== */
(function () {
  'use strict';

  var doc = document;
  var $ = function (s, r) { return (r || doc).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); };
  var drawer = $('#CartDrawer');
  var FREE = parseInt((drawer && drawer.getAttribute('data-free')) || '10000', 10);
  var LOW = 5; // en dessous, on affiche « Plus que X en stock »
  var T = function (k, d) { return window.SH4DE_T ? window.SH4DE_T(k, d) : d; };
  var ROOT = window.SH4DE_ROOT || '/';
  var loc = function (u) { u = String(u || ''); return (ROOT !== '/' && u.charAt(0) === '/' && u.indexOf(ROOT) !== 0) ? ROOT.replace(/\/$/, '') + u : u; };

  function money(c) {
    c = Number(c) || 0;
    return (c / 100).toLocaleString('fr-FR', {
      style: 'currency', currency: 'EUR',
      minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2
    });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function setCount(n) {
    $$('[data-kr-count]').forEach(function (b) {
      b.textContent = n;
      b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump');
    });
  }

  /* ------------------------------------------------------------------
     Tiroir panier
  ------------------------------------------------------------------ */
  var upData = [];
  try { upData = JSON.parse(($('[data-v2-up-data]') || {}).textContent || '[]'); } catch (e) { upData = []; }

  function shipBlock(sub) {
    var free = sub >= FREE;
    var p = Math.max(0, Math.min(100, sub / FREE * 100));
    var t = free
      ? T('free_ok', '<b>Livraison offerte</b> en France ✓')
      : T('free_left', 'Plus que <b>{amount}</b> pour la livraison offerte').replace('{amount}', money(FREE - sub));
    return { free: free, html: '<p class="v2-ship__t">' + t + '</p><div class="v2-ship__bar"><i style="--p:' + p.toFixed(1) + '%"></i></div>' };
  }

  function lineHTML(item, i) {
    var n = i + 1;
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? esc(T('size', 'Taille')) + ' ' + esc(item.variant_title) : '';
    return '' +
      '<div class="cart-line" data-line="' + n + '">' +
        '<a class="v2-line__img" href="' + esc(loc(item.url)) + '">' + (item.image ? '<img src="' + esc(sized(item.image, 200)) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div>' +
          '<div class="v2-line__top"><div><div class="v2-line__title">' + esc(item.product_title) + '</div>' +
          (variant ? '<div class="v2-line__var">' + variant + '</div>' : '') + '</div>' +
          '<div class="v2-line__price">' + money(item.final_line_price) + '</div></div>' +
          '<div class="v2-line__qty">' +
            '<button class="v2-qbtn" type="button" data-qty-minus data-line="' + n + '" aria-label="' + esc(T('minus', 'Retirer un')) + '">−</button>' +
            '<span class="v2-qval" data-qty-val>' + item.quantity + '</span>' +
            '<button class="v2-qbtn" type="button" data-qty-plus data-line="' + n + '" aria-label="' + esc(T('plus', 'Ajouter un')) + '">+</button>' +
            '<button class="v2-rm" type="button" data-qty-remove data-line="' + n + '">' + esc(T('remove', 'Retirer')) + '</button>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function upsellHTML(cart) {
    var inCart = {};
    cart.items.forEach(function (it) { inCart[it.handle] = true; });
    var p = upData.filter(function (x) {
      return x && !inCart[x.handle] && x.variants.some(function (v) { return v.available; });
    })[0];
    if (!p) return '';
    var sub = cart.items_subtotal_price;
    var line = '';
    if (sub < FREE && sub + p.price >= FREE) line = '<br><span>' + esc(T('upsell_free', 'Avec lui, ta livraison devient offerte.')) + '</span>';
    var sizes = p.variants.map(function (v) {
      return '<button type="button" data-v2-quick="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + esc(v.title) + '</button>';
    }).join('');
    return '' +
      '<div class="v2-dup">' +
        '<a class="v2-dup__img" href="' + esc(loc(p.url)) + '">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div><p class="v2-dup__t">' + esc(T('upsell', 'Complète le look :')) + ' <b>' + esc(p.title) + '</b> · ' + money(p.price) + line + '</p>' +
        '<p class="v2-dup__hint">' + esc(T('upsell_hint', 'Touche ta taille pour l\'ajouter :')) + '</p>' +
        '<div class="v2-dup__sizes" aria-label="' + esc(T('quick', 'Ajouter en un clic')) + '">' + sizes + '</div></div>' +
      '</div>';
  }

  function renderDrawer(cart) {
    var items = $('#CartItems'), total = $('#CartTotal'), ship = $('#CartShip');
    var up = $('#CartUpsell'), foot = $('[data-v2-foot]'), cnt = $('[data-v2-dcount]');
    if (!items || !cart) return;
    var empty = !cart.items.length;
    items.innerHTML = empty
      ? '<div class="v2-empty"><p>' + esc(T('empty', 'Ton panier est vide.')) + '</p><a class="v2-btn v2-btn--light" href="' + ROOT + '#drop">' + esc(T('see_drop', 'Voir le Drop 1')) + '</a></div>'
      : cart.items.map(lineHTML).join('');
    if (total) total.textContent = money(cart.total_price);
    if (ship) {
      var s = shipBlock(cart.items_subtotal_price);
      ship.innerHTML = s.html;
      ship.classList.toggle('is-free', s.free);
      ship.hidden = empty;
    }
    if (up) up.innerHTML = empty ? '' : upsellHTML(cart);
    if (foot) foot.hidden = empty;
    if (cnt) cnt.textContent = empty ? '' : '(' + cart.item_count + ')';
    setCount(cart.item_count);
  }
  // sh4de-cart.js et sh4de-kairo.js appellent cette fonction globale
  window.renderCartToDrawer = renderDrawer;

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }
  function openDrawer() {
    if (typeof window.openCartDrawer === 'function') window.openCartDrawer();
  }
  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(fetchCart)
      .then(function (cart) { renderDrawer(cart); openDrawer(); return cart; });
  }

  // ajout en un clic depuis le tiroir
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-v2-quick]');
      if (!b || b.disabled) return;
      b.classList.add('is-load');
      addItems([{ id: Number(b.getAttribute('data-v2-quick')), quantity: 1 }])
        .catch(function () { b.classList.remove('is-load'); });
    });
  }

  /* ------------------------------------------------------------------
     Sélecteurs de taille (cartes, combo, fiche produit, upsell)
  ------------------------------------------------------------------ */
  function pickerState(picker) {
    var input = $('[data-v2-id]', picker);
    return input ? input.value : '';
  }
  function initPicker(picker) {
    var input = $('[data-v2-id]', picker);
    var label = $('[data-v2-picked]', picker);
    var form = picker.closest('form');
    var msg = form ? $('[data-v2-msg]', form) : null;
    var buttons = $$('.v2-size', picker);
    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        buttons.forEach(function (o) { o.setAttribute('aria-checked', o === b ? 'true' : 'false'); });
        if (input) input.value = b.getAttribute('data-vid');
        if (label) { label.textContent = b.getAttribute('data-title'); label.classList.add('is-set'); }
        if (msg) {
          msg.classList.remove('is-err');
          var left = parseInt(b.getAttribute('data-left'), 10);
          msg.textContent = (left > 0 && left <= LOW) ? T('low', 'Plus que {n} en {size}, pas de restock garanti.').replace('{n}', left).replace('{size}', b.getAttribute('data-title')) : '';
        }
        if (form) {
          form.classList.add('has-size');
          var ex = $('[data-v2-express]', form);
          if (ex) ex.classList.add('is-on');
        }
      });
    });
  }
  $$('[data-v2-picker]').forEach(initPicker);

  function needSize(form, text) {
    var msg = $('[data-v2-msg]', form);
    if (msg) { msg.textContent = text; msg.classList.add('is-err'); }
    $$('.v2-sizes', form).forEach(function (s) {
      s.classList.remove('is-shake'); void s.offsetWidth; s.classList.add('is-shake');
    });
    var r = form.getBoundingClientRect();
    if (r.top < 80 || r.bottom > window.innerHeight) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function busy(btn, on, done) {
    if (!btn) return;
    if (!btn.getAttribute('data-label')) btn.setAttribute('data-label', btn.innerHTML);
    btn.classList.toggle('is-load', !!on);
    if (on) { btn.textContent = T('adding', 'Ajout…'); return; }
    if (done) {
      btn.classList.add('is-done'); btn.textContent = T('added', 'Ajouté ✓');
      setTimeout(function () { btn.classList.remove('is-done'); btn.innerHTML = btn.getAttribute('data-label'); }, 1800);
    } else {
      btn.innerHTML = btn.getAttribute('data-label');
    }
  }

  function submitForm(form) {
    var combo = form.hasAttribute('data-v2-combo');
    var pickers = $$('[data-v2-picker]', form);
    var btn = $('[data-v2-submit]', form);
    var msg = $('[data-v2-msg]', form);
    var items = [], missing = [];
    pickers.forEach(function (p) {
      var id = pickerState(p);
      if (id) items.push({ id: Number(id), quantity: 1 });
      else missing.push(p.getAttribute('data-name') || '');
    });
    if (!pickers.length) {
      var hid = $('[name=id]', form);
      if (hid && hid.value) items.push({ id: Number(hid.value), quantity: 1 });
    }
    if (missing.length || !items.length) {
      needSize(form, combo && missing.length > 1 ? T('pick_both', 'Choisis les deux tailles pour ajouter le combo.') : (combo ? T('pick_one', 'Choisis la taille du {name}.').replace('{name}', missing[0]) : T('pick_size', 'Choisis ta taille.')));
      return;
    }
    busy(btn, true);
    addItems(items)
      .then(function () { busy(btn, false, true); })
      .catch(function (err) {
        busy(btn, false, false);
        if (msg) {
          msg.classList.add('is-err');
          msg.textContent = (err && (err.description || err.message)) || T('error', 'Impossible d\'ajouter cette pièce. Réessaie dans un instant.');
        }
      });
  }

  $$('form[data-v2-add],form[data-v2-combo]').forEach(function (form) {
    form.addEventListener('submit', function (e) { e.preventDefault(); submitForm(form); });
  });

  /* ------------------------------------------------------------------
     Fiche produit : galerie, zoom, guide des tailles, barre collante
  ------------------------------------------------------------------ */
  $$('[data-v2-gal]').forEach(function (g) {
    var track = $('[data-v2-track]', g), cur = $('[data-v2-cur]', g), thumbs = $$('[data-v2-thumb]', g);
    if (!track) return;
    var idx = 0;
    function mark() {
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (i === idx) return;
      idx = i;
      if (cur) cur.textContent = i + 1;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      var t = thumbs[i];
      if (t && t.parentNode) t.parentNode.scrollTo({ left: t.offsetLeft - 16, behavior: 'smooth' });
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(mark); }, { passive: true });
    thumbs.forEach(function (t, k) {
      t.addEventListener('click', function () { track.scrollTo({ left: track.clientWidth * k, behavior: 'smooth' }); });
    });
    $$('img', track).forEach(function (im) {
      im.addEventListener('click', function () {
        var z = doc.createElement('div');
        z.className = 'v2-zoom';
        z.innerHTML = '<img src="' + esc(im.getAttribute('data-zoom') || im.currentSrc || im.src) + '" alt="">';
        z.addEventListener('click', function () { z.remove(); });
        doc.body.appendChild(z);
      });
    });
  });

  var guide = $('[data-v2-guide]');
  if (guide) {
    var open = function () { guide.hidden = false; };
    var close = function () { guide.hidden = true; };
    $$('[data-v2-guide-open]').forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-v2-guide-close]', guide).forEach(function (b) { b.addEventListener('click', close); });
    guide.addEventListener('click', function (e) { if (e.target === guide) close(); });
    doc.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  // Barre collante : visible tant que le bouton principal n'est pas à l'écran.
  // Sans taille choisie, elle amène au choix de la taille ; ensuite elle ajoute au panier.
  var sticky = $('[data-v2-sticky]');
  var cta = $('[data-v2-cta]');
  if (sticky && cta) {
    var mainForm = cta.closest('form');
    var sb = $('[data-v2-sticky-btn]', sticky);
    var hasSize = function () { var i = mainForm && $('[data-v2-id]', mainForm); return !!(i && i.value); };
    var label = function () { if (sb) sb.textContent = hasSize() ? T('add', 'Ajouter au panier') : T('choose_size', 'Choisir ma taille'); };
    label();
    if (mainForm) $$('.v2-size', mainForm).forEach(function (b) { b.addEventListener('click', label); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        var on = !es[0].isIntersecting;
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      }, { threshold: 0, rootMargin: '-100px 0px 0px 0px' }).observe(cta);
    }
    if (sb && mainForm) sb.addEventListener('click', function () {
      if (hasSize()) { submitForm(mainForm); return; }
      var sizes = $('.v2-sizes', mainForm) || mainForm;
      sizes.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }
})();
